<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              參數設定
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              LINE 查詢
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">LINE 查詢</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="LINE UID"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="uid"
              :class="{'is-invalid': v$.uid.$error}"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                class="mr-2"
                variant="info"
                @click="handleSearch"
                :disabled="isLoading"
              >
              查詢
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback v-if="v$.uid.$error">
              請輸入uid
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="LINE UID"
        >
          <b-form-input
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="profile.userId"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="顯示名稱"
        >
          <b-form-input
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="profile.displayName"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="大頭貼"
        >
          <div v-if="profile.pictureUrl !== ''">
            <img :src="profile.pictureUrl" alt="大頭貼" style="max-width: 100px; border-radius: 8px;" />
          </div>
          <div v-else>
            <!-- 不顯示任何東西，或可放預設文字/圖片 -->
          </div>
        </b-form-group>
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="result"
          width="100%"
          height="200px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="!editable"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import lineApi from "@/apis/line"

export default {
  mixins: [fileMixin],
  components: { editor },
  validationConfig: {
    $lazy: true,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      uid: {
        required: helpers.withMessage('請輸入 UID', required),
      },
    };
  },
  data() {
    return {
      code: null,
      uid: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
      canEdit: false,
      profile : {
        displayName : '',
        userId : '',
        pictureUrl  : ''
      }
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    },
    editable() {
      return !this.isShownByVariableCode || this.canEdit
    },
  },
  mounted() {
    if (!this.checkPermission([consts.LINE_QUERY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    } else if (this.moduleId || this.isShownByVariableCode) {
      this.fetchModule();
    }
  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },
    async handleSearch() {
      const result = await this.v$.$validate();
      if (!result) return;

      this.profile = { displayName: '', userId: '', pictureUrl: '' };

      try {
        this.isSubmitting = true;
        this.result = "查詢中...";
        const result = await lineApi.searchUid(
          this.orgId,
          {
            uid: this.uid,
          }
        );
        this.result = JSON.stringify(result.data, null, 2);

        console.log(result.data);
        // 新增這段
        if (result.data && result.data.profile) {
          this.profile = result.data.profile;
        }

        console.log(this.profile);

      } catch (error) {
        this.result = JSON.stringify(error.response.data, null, 2);
        console.log(this.result)
      }
      this.isSubmitting = false;
    },
    // async handleSubmit(redirect = true) {
    //   const result = await this.v$.$validate();
    //   if (!result) return;
    //   this.handleUpdate(redirect);
    // },
    showSuccessPopup(redirect = true) {
      this.$swal
        .fire({
          type: "success",
          text: "修改成功",
        })
        .then(() => {
          if (redirect) {
            this.$router.push({
              name: this.isByMerchant
                ? "OrganizationVariableListByMerchant"
                : "OrganizationVariableList",
            });
          }
        });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>
